/**
 * Toolbar — a flex-row container for action buttons / controls.
 *
 * Thin layout primitive: aligns its children in a row with a token-sized
 * gap. Used for panel header button clusters (Copy / Clear / filter toggles)
 * and footer action rows.
 */
import React, { type ReactNode } from 'react';
import { SPACE, type SpaceKey } from '../theme';

export type ToolbarAlign = 'start' | 'center' | 'end' | 'between';

export interface ToolbarProps {
  children: ReactNode;
  align?: ToolbarAlign;
  gap?: SpaceKey;
}

function justify(align: ToolbarAlign): React.CSSProperties['justifyContent'] {
  switch (align) {
    case 'start': return 'flex-start';
    case 'center': return 'center';
    case 'end': return 'flex-end';
    case 'between': return 'space-between';
  }
}

export function Toolbar({ children, align = 'start', gap = 'sm' }: ToolbarProps): React.ReactElement {
  const toolbarStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    justifyContent: justify(align),
    gap: SPACE[gap],
  };

  return <div style={toolbarStyle}>{children}</div>;
}
